<template>
  <li :class="{'tab-title': true, 'active': active}" @click.prevent="activate">
    <a :id="idValue" :aria-selected="active" :href="hrefValue" :aria-controls="ariaControls" tabindex="0">{{ title }}</a>
  </li>
</template>

<script>
export default {
  name: 'TabButton',
  props: {
    name: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    active: {
      type: Boolean,
      required: true
    },
    href: {
      type: String,
      required: false,
      default: ''
    },
    ariaControls: {
      type: String,
      required: false,
      default: 'card'
    }
  },
  computed: {
    idValue: function () {
      return `${this.name}-link`
    },
    hrefValue: function () {
      return this.href !== '' ? this.href : `#${this.name}-panel`
    }
  },
  methods: {
    activate: function () {
      this.$emit('click')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tabs/TabButton.vue